// extracted by mini-css-extract-plugin
export default {"QuestsList":"QuestsList_QuestsList__441Pl","QuestItem":"QuestsList_QuestItem__9iYbX","QuestTitle":"QuestsList_QuestTitle__m6vBD"};